<template>
  <header class="landing-header">
    <div class="background-fill"></div>
    <div class="header-wrapper">
      <div class="autodesk-logo-parent" @click="navigateHome()">
        <div class="autodesk-logo"></div>
      </div>
    </div>
  </header>
</template>

<script>
  import CONSTANTS from "@/constants";
export default {
  name: "simple-header",
  computed: {},
  methods: {
    navigateHome() {
      location.href = CONSTANTS.LANDING_PAGE_URL;
    },
  }
};
</script>
<style scoped>
.background-fill {
  background: #fff;
  width: 100%;
  height: 60px;
  position: absolute;
}

.autodesk-logo {
  width: 160px;
  height: 60px;
  background: url(https://d2w32r1l9bag3.cloudfront.net/employee-hub-logo.svg) center
    center no-repeat;
  margin-top: 0;
  background-size: contain;
}
.autodesk-logo-parent {
  float: left;
  padding: 0 10px;
  line-height: 60px;
  color: #373435;
  font-size: 45px;
  cursor: pointer;
  text-transform: uppercase;
  position: absolute;
}
.header-wrapper {
  padding-left: 15px;
  padding-right: 15px;
}
.landing-header {
  height: 60px;
  width: 100%;
}
</style>

